import { AfterViewInit, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { FilterChipItem } from '../../models/filter-chip.model';

@Component({
  selector: 'filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss']
})
export class FilterChipComponent implements AfterViewInit {

  @Input() list: FilterChipItem[];
  @ViewChildren('chips') chips: QueryList<ElementRef>;

  constructor() { }

  ngAfterViewInit(): void {
    const activeChip = this.list.findIndex(i => i.isActive);
    if(activeChip === -1) return;
    this.scrollTo(this.chips.toArray()[activeChip].nativeElement);
  }

  private scrollTo(el: any) {
    const elRight = el.offsetLeft + el.offsetWidth;
    const elLeft = el.offsetLeft;

    const elParentRight = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
    const elParentLeft = el.parentNode.offsetLeft;

    // check if right side of the element is not in view
    if (elRight > elParentRight + el.parentNode.scrollLeft) {
      el.parentNode.scrollLeft = elRight - elParentRight;
    }

    // check if left side of the element is not in view
    else if (elLeft < elParentLeft + el.parentNode.scrollLeft) {
      el.parentNode.scrollLeft = elLeft - elParentLeft;
    }
  }

}
